import { render } from "./IDrivers.vue?vue&type=template&id=35b31e80"
import script from "./IDrivers.vue?vue&type=script&lang=js"
export * from "./IDrivers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__